import {Tab as HUITab} from '@headlessui/react'
import {twJoin} from 'tailwind-merge'

import {twMerge} from '@sdox/utils'

import type {MouseEventHandler, ReactNode} from 'react'
import type {TabProps as HUITabProps} from '@headlessui/react'

export interface TabProps extends Omit<HUITabProps, 'className'> {
  children: ReactNode
  className?: string
}

export const Tab = (props: TabProps) => {
  const {children, className, ...restProps} = props

  const onClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.currentTarget?.scrollIntoView({behavior: 'smooth'})
  }

  return (
    <HUITab
      className={twMerge(
        'group flex min-w-spacing-32 shrink-0 flex-col justify-center gap-spacing-4 focus:outline-none',
        'text-p1 text-interactive-glyph-default-primary',
        className,
      )}
      onClick={onClick}
      {...restProps}
    >
      <div className={'flex h-spacing-44 items-center px-spacing-16'}>
        {children}
      </div>
      <div
        className={twJoin(
          'relative block h-spacing-4 w-full overflow-hidden rounded-t-radius-interactive-sm',
          'group-data-[selected]:bg-interactive-surface-filled-brand-default',
        )}
      >
        <div
          className={twJoin(
            'absolute inset-0',
            'group-hover:bg-scrim-primary/15',
            'group-data-[active]:bg-scrim-primary/30',
          )}
        />
      </div>
    </HUITab>
  )
}
